import type { EmberChangeset } from 'ember-changeset';
import t from 'ember-intl/helpers/t';
import FeelingEvasSectionContent from 'parog-web/components/feeling-evas/sliders/component';
import type ForcJournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import Slider from 'parog-web/components/mici/base-consult-form/slider';

interface Signature {
  Args: {
    form: { changeset: EmberChangeset };
    forcComponent: ForcJournalEventBasedComponent;
  };
}

export default class extends FeelingEvasSectionContent<Signature> {
  <template>
    <Slider
      @form={{@form}}
      @forcComponent={{@forcComponent}}
      @key='socialDifficulties'
    >
      <:header>
        <div>
          <div class='text-black'>{{t
              'mici-form.socialDifficulties.long'
              htmlSafe=true
            }}</div>
        </div>
      </:header>
      <:lowest>
        Je ne suis pas du tout d'accord (0)
      </:lowest>
      <:highest>
        Je suis tout à fait d'accord (10)
      </:highest>
    </Slider>
  </template>
}
